import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { toast } from "react-toastify";
// import { PageChanger } from "../../../GobalStyled";
import { VideoReport } from "../Auth/_redux/authCrud";
import {
  MdOutlineKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";

export default function ReportedVideo() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState(3);
  // const [page, setPage] = useState(1);

  // eslint-disable-next-line no-unused-vars
  const baseurl = "https://d17am3tdlggecz.cloudfront.net/";
  const history = useHistory();
  const location = useLocation();

  // const sortData = (data) => {
  //   let sort = data.sort((a, b) => {
  //     return a.status - b.status;
  //   });
  //   setData(sort);
  // };
  const getbtnClasses = (status) => {
    if (status === 3) {
      return "danger";
    } else if (status === 2) {
      return "dark";
    }
    return "success";
  };

  const getAllReportListing = async () => {
    setLoading(true);
    setFilter(3);
    //filter to list all reports as per the actions taken on them by admin
    let res = await VideoReport();
    // console.log(res);
    if (res.status === 200) {
      // console.log(res.data, "resssssssss--------");
      // sortData(res.data);
      setData(res.data);
      setLoading(false);
    } else {
      setLoading(false);
      toast.error();
    }
  };

  useEffect(() => {
    getAllReportListing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const VideoSlider = ({ mediaUrls, baseurl }) => {
    const [index, setIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const mediaArray = Array.isArray(mediaUrls)
      ? mediaUrls
      : mediaUrls
        ? [mediaUrls]
        : [];

    const next = () => {
      setIsLoading(true);
      setHasError(false);
      setIndex((prev) => (prev + 1) % mediaArray.length);
    };

    const prev = () => {
      setIsLoading(true);
      setHasError(false);
      setIndex((prev) => (prev - 1 + mediaArray.length) % mediaArray.length);
    };

    if (mediaArray.length === 0) return null;

    return (
      <div>
        {/* Loader */}
        {isLoading && !hasError && (
          <div
            style={{
              height: "145px",
              width: "250px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f2f2f2",
              fontSize: "12px",
            }}
          >
            Loading video...
          </div>
        )}

        {/* Error fallback */}
        {hasError && (
          <div
            style={{
              height: "145px",
              width: "250px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#ffe6e69c",
              color: "#d32f2f",
              fontSize: "12px",
            }}
          >
            Video failed to load
          </div>
        )}

        {/* Video */}
        {!hasError && (
          <video
            key={index} // important: reload video on index change
            style={{
              height: "145px",
              width: "250px",
              display: isLoading ? "none" : "block",
            }}
            src={baseurl + mediaArray[index]}
            autoPlay
            muted
            playsInline
            onLoadedData={() => setIsLoading(false)}
            onError={() => {
              setIsLoading(false);
              setHasError(true);
            }}
          />
        )}

        {/* Controls */}
        {mediaArray.length > 1 && !hasError && (
          <div className="mt-2 d-flex justify-content-between">
            <button onClick={prev}>
              <MdOutlineKeyboardArrowLeft />
            </button>
            <button onClick={next}>
              <MdKeyboardArrowRight />
            </button>
          </div>
        )}
      </div>
    );
  };

  // const getLatestReportDate = (reportData = []) => {
  //   if (!Array.isArray(reportData) || reportData.length === 0) return 0;

  //   return Math.max(...reportData.map((r) => new Date(r.created_at).getTime()))
  // };

  //  const getLatestReportDate = (reportData = []) => {
  //     if (!Array.isArray(reportData)) return [];

  //   return [...reportData].sort(
  //     (a, b) => new Date(b.created_at) - new Date(a.created_at)
  //   );
  //   }; 

  if (loading) {
    return (
      <div className="LoaderWrapper">
        <div className="BackgroundLoader" />
      </div>
    );
  }

  return (
    <div className={`card card-custom `}>
      {/* Head */}

      {/* Body */}
      <div className="card-body pt-3 pb-2 my-4">
        <div className="tab-content">
          <div className="table-responsive">
            <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
              <thead>
                <tr className="text-left text-uppercase ">
                  {/* <th className="pl-2" style={{ minWidth: "100px" }}></th> */}
                  <th className="pl-2" style={{ minWidth: "150px" }}>
                    Reported Video
                  </th>
                  <th className="pl-2" style={{ minWidth: "150px" }}>
                    Business Profile
                  </th>
                  {/* <th className="pl-2" style={{ minWidth: "150px" }}>
                    Reported By
                  </th> */}
                  {/* <th style={{ minWidth: "200px" }}>Reason</th> */}
                  <th style={{ minWidth: "40px" }}>Count</th>
                  {/* <th style={{ minWidth: "20px" }}>Status</th> */}
                  <th className="text-center" style={{ minWidth: "20px" }}>
                    action
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* {data
                  ?.sort(
                    (a, b) =>
                      getLatestReportDate(b.reportData) -
                      getLatestReportDate(a.reportData)
                  )
                  ?.filter((item) => {
                    const hasArray =
                      Array.isArray(
                        item?.mediaUrls?.filter(
                          (url) => !url.includes("isDeactivated=true")
                        )
                      ) &&
                      item?.mediaUrls?.filter(
                        (url) => !url.includes("isDeactivated=true")
                      ).length > 0;
                    const hasString = item?.mediaUrl && item?.mediaUrl !== "";
                    return hasArray || hasString;
                  }) */}
                {data

                  ?.filter((item) => {
                    const hasArray =
                      Array.isArray(item?.mediaUrls) &&
                      item?.mediaUrls.length > 0;
                    const hasString = item?.mediaUrl && item?.mediaUrl !== "";
                    return hasArray || hasString;
                  })
                  .map((item) => (
                    <tr className="border-bottom" key={item._id}>
                      <td className="pl-0 py-8">
                        <div className="d-flex align-items-center">
                          <VideoSlider
                            // mediaUrls={
                            //   item?.mediaUrl
                            //     ? [item?.mediaUrl]?.filter(
                            //         (url) =>
                            //           !url?.includes("isDeactivated=true")
                            //       )
                            //     : Array.isArray(item?.mediaUrls)
                            //     ? item?.mediaUrls?.filter(
                            //         (url) =>
                            //           !url?.includes("isDeactivated=true")
                            //       )
                            //     : item?.mediaUrls
                            //     ? [item.mediaUrls]?.filter(
                            //         (url) =>
                            //           !url?.includes("isDeactivated=true")
                            //       )
                            //     : // : item?.mediaUrl
                            //       // ? [item?.mediaUrl]?.filter(
                            //       //     (url) => !url?.includes("isDeactivated=true")
                            //       //   )
                            //       []
                            // }
                            mediaUrls={
                              item?.mediaUrl
                                ? [item?.mediaUrl]
                                : Array.isArray(item?.mediaUrls)
                                  ? item?.mediaUrls
                                  : item?.mediaUrls
                                    ? [item.mediaUrls]
                                    : // : item?.mediaUrl
                                    // ? [item?.mediaUrl]?.filter(
                                    //     (url) => !url?.includes("isDeactivated=true")
                                    //   )
                                    []
                            }
                            baseurl={baseurl}
                          />
                        </div>
                      </td>
                      <td className="pl-0 py-8">
                        <div className="d-flex align-items-center">
                          <button
                            onClick={() =>
                              history.push("/user-details", {
                                id: item?.postProfileNewData.map(
                                  (item) => item._id
                                ),
                                path: location?.pathname,
                              })
                            }
                            className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg btn btn-link"
                            style={{
                              padding: 0,
                              border: "none",
                              background: "none",
                            }}
                          >
                            {item?.postProfileNewData[0]?.first_name || "-"}{" "}
                            {item?.postProfileNewData[0]?.last_name}

                          </button>
                        </div>
                      </td>

                      {/* <td className="pl-0 py-8">
                        <div className="d-flex align-items-center">
                          <button
                            onClick={() =>
                              history.push("/user-details", {
                                id: item?.postProfileData.map(
                                  (item) => item._id
                                ),
                
                                path: location?.pathname,
                              })
                            }
                            className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg btn btn-link"
                            style={{
                              padding: 0,
                              border: "none",
                              background: "none",
                            }}
                          >
                            {item?.reportedByUserData[0]?.first_name || "-"}{" "}
                            {item?.reportedByUserData[0]?.last_name}
                          </button>
                        </div>
                      </td> */}
                      <td>
                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                          {item?.count}
                          {/* {item.reportData.map((x) => x.created_at)} */}
                        </span>
                      </td>
                      <td className="pr-0 text-center">
                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                          <button
                            className={`btn btn-light-${getbtnClasses(
                              item.status
                            )} font-weight-bolder font-size-sm mx-1`}
                            // onClick={() => {
                            //   setPreviewVideos(item.mediaUrls || item.mediaUrl);
                            //   setPreviewOpen(true);
                            // }}

                            onClick={() =>
                              history.push("/view-Reported-Video", {
                                data: item,
                                path: location.pathname,
                              })
                            }
                          >
                            View
                          </button>
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* {previewOpen && (
        <div
          style={{
            position: "fixed",
            overflow: "auto",
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            inset: 0,
          }}
          onClick={() => setPreviewOpen(false)}
        >
          <div
            style={{
              background: "#ffffffd3",
              padding: 20,
              borderRadius: 8,
              width: "100%",
              height: "100%",
              maxWidth: "700px",
              maxHeight: "70vh",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <VideoSlider2 mediaUrls={previewVideos} baseurl={baseurl} />

            <button
              className="btn btn-danger mt-3 rounded-circle d-flex justify-content-center align-items-center text-[30px]"
              //  className=" rounded-full d-flex items-center justify-center mt-6 w-30 h-30 text-[34px] cursor-pointer btn-danger"
              onClick={() => setPreviewOpen(false)}
            >
              x
            </button>
          </div>
        </div>
      )} */}

      {/* <PageChanger>
        {page > 1 && (
          <span
            onClick={() => {
              if (page > 1) {
                setPage(page - 1);
              }
            }}
          >
            Go Back
          </span>
        )}
        {/* <span>{page}</span> 
        {data.length > 20 && (
          <span className="active" onClick={() => setPage(page + 1)}>
            See More
          </span>
        )}
      </PageChanger> */}
    </div>
  );
}
